// Business-wide configuration.
export const BUSINESS = {
  name: "KJ CUSTOM",
  shortName: "KJ CUSTOM",
  location: "Southern California",
  phone: "562-405-1752",
  phoneTel: "tel:+15624051752",
  email: "Kandjmoss@gmail.com",
  emailMailto: "mailto:Kandjmoss@gmail.com",
  // Calendly URL — update when available
  calendlyUrl: "https://calendly.com/",
  responseTime: "Same-day quote response",
  logoSrc: "/logo.jpeg",
};

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
